import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import Hero from '../components/common/Hero';
import InfiniteTicker from '../components/common/InfiniteTicker';
import CategoryGrid from '../components/common/CategoryGrid';
import NewArrivals from '../components/common/NewArrivals';
import BestSellers from '../components/common/BestSellers';
import Values from '../components/common/Values';
import LoveLetters from '../components/common/LoveLetters';
import Footer from '../components/layout/Footer';

const Home = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Box>
            <Hero />
            <InfiniteTicker />
            <CategoryGrid />
            <NewArrivals />
            <BestSellers />
            <Values />
            <LoveLetters />
            <Footer />
        </Box>
    );
};

export default Home;
